/*
 * Copyright (C) 2023 Pitagon., JSC. - All Rights Reserved.
 *
 * Unauthorized copying or redistribution of this file in source and binary forms via any medium
 * is strictly prohibited.
 */

export const  ALERT_CHAT_TOPIC = '/chat-message/alert';
